import checkFF from '@webapp-next/lib/feature-flag';

export function checkEndEmploymentFF(): boolean {
  return checkFF('payx-262-enable-employment-end-date-and-reason');
}

export function checkEmploymentCollapseFF(): boolean {
  return checkFF('pre-6114-employment-collapse');
}

export function checkShiftHandlingChooserFF(): boolean {
  return checkFF('payx-2419-shift-handling-chooser');
}

const COLLAPSE_AGREEMENT_THRESHOLD = 1000;

export function isAboveCollapseThreshold(agreementCount: number): boolean {
  return agreementCount > COLLAPSE_AGREEMENT_THRESHOLD;
}
